module.exports = __webpack_public_path__ + "media/staff/default_male-80096803.png";